import * as fabric from 'office-ui-fabric-react';
import React, { FC } from 'react';
import { ChoiceEnum, IFilterSettings } from './Queue';

interface IProps {
    ticketsSettings: IFilterSettings;
    setTicketsSettings: Function;
    componentKey: number;
}

const dropDownStyles = {
    title: {
        borderRadius: '7px',
        backgroundColor: 'rgb(230, 231, 232)'
    }
};

const TicketsFilter: FC<IProps> = ({ ticketsSettings, setTicketsSettings, componentKey }) => {
    return (
        <fabric.StackItem className="ticketsColumnFilter">
            <div className="ticketsColumnFilter-widthAdjuster">
                {ticketsSettings.serviceFilterOptionKeys.length > 0 && (
                    <fabric.Dropdown
                        styles={dropDownStyles}
                        multiSelect={true}
                        className="ticketsColumnDropdown"
                        options={ticketsSettings.serviceFilterOptionKeys}
                        selectedKeys={ticketsSettings.serviceFilterOptionKeys.filter(e => e.selected).map(e => e.key.toString())}
                        onChange={(event, option?: fabric.IDropdownOption | undefined) => {
                            setTicketsSettings({
                                ...ticketsSettings,
                                serviceFilterOptionKeys: ticketsSettings.serviceFilterOptionKeys.map(e =>
                                    e.key === option?.key ? { ...e, selected: option.selected } : e
                                )
                            });
                        }}
                    />
                )}
                <div className="ticketsColumnFilter-spaceBetween">
                    <div className="inlineFlex">
                        <input
                            className="inlineFlex-radioButton"
                            checked={ticketsSettings.choiceGroupValue === ChoiceEnum.ByArrivalTime}
                            onChange={() => setTicketsSettings({ ...ticketsSettings, choiceGroupValue: 1 })}
                            type="radio"
                            name={componentKey.toString()}
                            id={componentKey + 'byArrivalTime'}
                        />
                        <label className="inlineFlex-labels">pagal atvykimo laiką</label>
                    </div>
                    <div className="inlineFlex">
                        <input
                            className="inlineFlex-radioButton"
                            type="radio"
                            name={componentKey.toString()}
                            id={componentKey + 'byVisitTime'}
                            onChange={() => setTicketsSettings({ ...ticketsSettings, choiceGroupValue: 2 })}
                            checked={ticketsSettings.choiceGroupValue === ChoiceEnum.ByVisitTime}
                            disabled={
                                !(
                                    ticketsSettings.serviceFilterOptionKeys.filter(x => x.key === '0' && x.selected === true).length === 1 &&
                                    ticketsSettings.serviceFilterOptionKeys.filter(x => x.selected === true).length === 1
                                )
                            }
                        />
                        <label className="inlineFlex-labels">pagal vizito laiką</label>
                    </div>
                </div>
            </div>
        </fabric.StackItem>
    );
};

export default TicketsFilter;
